import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
  async ObtenerGruposEncuestas(vm) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Calidad/ObtenerGruposEncuestas`)
      .then((response) => {
        vm.conceptosArray = response.data;
      });
  },
  async verificarEncuesta(vm) {
    var formData = new FormData();
    formData.append("tipoEncuesta", vm.datos.tipoencuesta.egid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/VerificarEncuesta`,
      formData
    );

    return response.data;
  },
  async ObtenerListadoEstatus(vm) {
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/ObtenerListadoEstatus`
    );

    return response.data;
  },

  async ObtenerLeyendasEncuesta(vm) {
    var formData = new FormData();
    formData.append("tipoEncuesta", vm.datos.tipoencuesta.egid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/ObtenerLeyendasEncuesta`,
      formData
    );

    return response.data;
  },

  async ObtenerPreguntasEncuesta(vm) {
    var formData = new FormData();
    formData.append("tipoEncuesta", vm.datos.tipoencuesta.egid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);

    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/ObtenerPreguntasEncuesta`,
      formData
    );

    return response.data;
  },
  async ObtenerRespuestasEncuesta2(vm) {
    let respuestas = [];
    for (let i = 0; i < vm.formulariopreguntas.length; i++) {
      var formData = new FormData();
      formData.append("evid", vm.formulariopreguntas[i].evid);
      let response = await vm.axios.post(
        `${vm.domain.domainNameForApi}Calidad/ObtenerRespuestasEncuesta`,
        formData
      );
      respuestas.push(response.data);
    }

    return respuestas;
  },
  async ObtenerRespuestasEncuestaDetalle(vm) {
    let respuestas = [];
    for (let i = 0; i < vm.formulariopreguntas.length; i++) {
      var formData = new FormData();
      formData.append("evid", vm.formulariopreguntas[i].evid);
      formData.append("nrreporte", vm.datos.nrreporte);
      formData.append("svindice", vm.datos.svindice);
      let response = await vm.axios.post(
        `${vm.domain.domainNameForApi}Calidad/ObtenerRespuestasEncuestaDetalle`,
        formData
      );
      respuestas.push(response.data);
    }

    return respuestas;
  },

  async ObtenerListadoMotivo(vm) {
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/ObtenerListadoMotivo`
    );

    return response.data;
  },

  async guardarEncuesta(vm) {
    var formData = new FormData();
    formData.append("respuestas", JSON.stringify(vm.valueradio));
    formData.append("tipoEncuesta", vm.datos.tipoencuesta.egid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);

    return axios
      .post(`${domain.domainNameForApi}Calidad/GuardarEncuesta`, formData)
      .then((response) => response.data);
  },


  async guardarEstatus(vm) {
    var formData = new FormData();
    formData.append("esid", vm.estatus);
    formData.append("tipoEncuesta", vm.datos.tipoencuesta.egid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("motivoNA", vm.motivoNA);

    return axios
      .post(`${domain.domainNameForApi}Calidad/GuardarEstatus`, formData)
      .then((response) => response.data);
  },

  async BuscarContestadas(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datosE.nrreporte);
    formData.append("svindice", vm.datosE.svindice);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/BuscarContestadas`,
      formData
    );

    return response.data;
  },

  async ObtenerPreguntasEncuestaDetalle(vm) {
    var formData = new FormData();
    formData.append("tipoEncuesta", vm.datos.tipoencuesta.egid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);

    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/ObtenerPreguntasEncuestaDetalle`,
      formData
    );

    return response.data;
  },

  async obtenerEstatusEncuesta(vm) {
    var formData = new FormData();
    formData.append("tipoEncuesta", vm.datos.tipoencuesta.egid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/obtenerEstatusEncuesta`,
      formData
    );

    return response.data;
  },

  async guardarClasificacion(vm) {
    var formData = new FormData();
    formData.append("tipoEncuesta", vm.datos.tipoencuesta.egid);
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice);
    formData.append("motivo", vm.motivo);

    return axios
      .post(`${domain.domainNameForApi}Calidad/GuardarClasificacion`, formData)
      .then((response) => response.data);
  },

  async ObtenerTipoEncuestasGrafica(vm) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Calidad/ObtenerTipoEncuestasGrafica`)
      .then((response) => {
        vm.encuestasArray = response.data;
      });
  },
  async ObtenerClientes(vm) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Calidad/ObtenerClientes`)
      .then((response) => {
        vm.clientesArray = response.data;
      });
  },

  async ObtenerGerencias(vm) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Calidad/ObtenerGerencias`)
      .then((response) => {
        vm.gerenciasArray = response.data;
      });
  },

  async obtenerDatosGrafica(vm) {
    var formData = new FormData();
    formData.append("egid", vm.datos.tipoencuesta.egid);
    formData.append(
      "clclave",
      vm.datos.cliente.length == 0
        ? "null"
        : vm.datos.cliente.map((objeto) => objeto.clclave).join(",")
    ); //JSON.stringify(vm.datos.cliente));
    formData.append(
      "gerencias",
      vm.datos.gerencia.length == 0
        ? "null"
        : vm.datos.gerencia.map((objeto) => objeto.geclave).join(",")
    );
    formData.append("fechainicio", vm.datos.fechaIni);
    formData.append("fechafinal", vm.datos.fechaFin);
    formData.append("agrupacion", vm.datos.agrupacion);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Calidad/obtenerDatosGrafica`,
      formData
    );

    return response.data;
  },

  /* AGENTES */
  async ObtenerAgentes(vm) {
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/ObtenerAgentes`);
    return resp.data;
  },
  async BuscarLlamada(vm, nrreporte, svindice, nomreArchivo) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("nomreArchivo", nomreArchivo);
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/BuscarLlamada`, formData);
    return resp.data;
  },
  async InciarProcesoAgentes(vm, nrreporte, svindice, docid) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("docid", docid);
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/InciarProcesoAgentes`, formData);
    return resp.data;
  },
  async AgentesCalificados(vm) {
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/AgentesCalificados`);
    return resp.data;
  },
  async GuardarCalificacion(vm, agcuslogin, nrreporte, svindice, docid,
    calificacionAmabilidadEntrada, motivoAmabilidadEntrada, calificacionIdentificoEntrada, motivoIdentificoEntrada, calificacionNombreEntrada, motivoNombreEntrada,
    calificacionAmabilidadTrato, motivoAmabilidadTrato, calificacionNombreTrato, motivoNombreTrato,
    calificacionGustoTrato, motivoGustoTrato, calificacionEmocionesTrato, motivoEmocionesTrato, calificacionConfianzaActitud, motivoConfianzaActitud,
    calificacionDiademaDesarrollo, motivoDiademaDesarrollo, calificacionRitmoDesarrollo, motivoRitmoDesarrollo, calificacionEsperaDesarrollo, motivoEsperaDesarrollo,
    calificacionMuletillasDesarrollo, motivoMuletillasDesarrollo, calificacionSonidoDesarrollo, motivoSonidosDesarrollo,
    calificacionMensajeDicción, motivoMensajeDicción, calificacionVozDicción, motivoVozDicción, calificacionPronuncioDicción, motivoPronuncioDicción,
    calificacionReporteSalida, motivoReporteSalida, calificacionNombreSalida, motivoNombreSalida, calificacionHoraSalida, motivoHoraSalida,
    calificacionSeguimientoSalida, motivoSeguimientoSalida, mejoraGeneral, calificacionContestarEntrada, motivoContestarEntrada) {
    var formData = new FormData();
    formData.append("agcuslogin", agcuslogin);
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("docid", docid);

    formData.append("agcamabilidad_entrada", calificacionAmabilidadEntrada);
    formData.append("agcamabilidad_entradaMotivo", motivoAmabilidadEntrada);
    formData.append("agcidentificar_entrada", calificacionIdentificoEntrada);
    formData.append("agcidentificar_entradaMotivo", motivoIdentificoEntrada);
    formData.append("agcnombre_entrada", calificacionNombreEntrada);
    formData.append("agcnombre_entradaMotivo", motivoNombreEntrada);
    formData.append("agccontestar_entrada", calificacionContestarEntrada);
    formData.append("agccontestar_entradaMotivo", motivoContestarEntrada);

    formData.append("agcamabilidad_trato", calificacionAmabilidadTrato);
    formData.append("agcamabilidad_tratoMotivo", motivoAmabilidadTrato);
    formData.append("agcnombre_trato", calificacionNombreTrato);
    formData.append("agcnombre_tratoMotivo", motivoNombreTrato);

    formData.append("agcgusto_actitud", calificacionGustoTrato);
    formData.append("agcgusto_actitudMotivo", motivoGustoTrato);
    formData.append("agcemociones_actitud", calificacionEmocionesTrato);
    formData.append("agcemociones_actitudMotivo", motivoEmocionesTrato);
    formData.append("agcconfianza_actitud", calificacionConfianzaActitud);
    formData.append("agcconfianza_actitudMotivo", motivoConfianzaActitud);

    formData.append("agcdiadema_desarrollo", calificacionDiademaDesarrollo);
    formData.append("agcdiadema_desarrolloMotivo", motivoDiademaDesarrollo);
    formData.append("agcritmo_desarrollo", calificacionRitmoDesarrollo);
    formData.append("agcritmo_desarrolloMotivo", motivoRitmoDesarrollo);
    formData.append("agcespera_desarrollo", calificacionEsperaDesarrollo);
    formData.append("agcespera_desarrolloMotivo", motivoEsperaDesarrollo);
    formData.append("agcmuletillas_desarrollo", calificacionMuletillasDesarrollo);
    formData.append("agcmuletillas_desarrolloMotivo", motivoMuletillasDesarrollo);
    formData.append("agcsonidos_desarrollo", calificacionSonidoDesarrollo);
    formData.append("agcsonidos_desarrolloMotivo", motivoSonidosDesarrollo);

    formData.append("agcmensaje_diccion", calificacionMensajeDicción);
    formData.append("agcmensaje_diccionMotivo", motivoMensajeDicción);
    formData.append("agcvoz_diccion", calificacionVozDicción);
    formData.append("agcvoz_diccionMotivo", motivoVozDicción);
    formData.append("agcpronuncio_diccion", calificacionPronuncioDicción);
    formData.append("agcpronuncio_diccionMotivo", motivoPronuncioDicción);

    formData.append("agcreporte_salida", calificacionReporteSalida);
    formData.append("agcreporte_salidaMotivo", motivoReporteSalida);
    formData.append("agcnombre_salida", calificacionNombreSalida);
    formData.append("agcnombre_salidaMotivo", motivoNombreSalida);
    formData.append("agchora_salida", calificacionHoraSalida);
    formData.append("agchora_salidaMotivo", motivoHoraSalida);
    formData.append("agcseguimiento_salida", calificacionSeguimientoSalida);
    formData.append("agcseguimiento_salidaMotivo", motivoSeguimientoSalida);

    formData.append("agcmejora", mejoraGeneral);

    formData.append("uslogin", MetodosGenerales.ObtenerUserName());
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/GuardarCalificacion`, formData);
    return resp.data;
  },
  async GuardarCalificacionesFinales(vm, pccaid, calificacion, reaid, motivo) {

    var formData = new FormData();
    formData.append("pccaid", pccaid);
    formData.append("calificacion", calificacion);
    formData.append("reaid", reaid);
    formData.append("motivo", motivo);
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/GuardarCalificacionesFinales`, formData);
    return resp.data;
  },
  async ObtenerRetroalimentacion(vm, nrreporte, svindice) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/ObtenerRetroalimentacion`, formData);
    return resp.data;
  },
  async AgentesCalificadosExcel(vm) {
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/AgentesCalificadosExcel`);
    return resp.data;
  },
  async ValidarInformacion(vm, nrreporte, svindice, reporte, estado, localidad, tipoCovertura,
    titularPoliza, telefono, fechaSiniestro, marca, model, anio, color, conductor, sinllamda) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("reporte", reporte);
    formData.append("estado", estado);
    formData.append("localidad", localidad);
    formData.append("tipoCovertura", tipoCovertura);
    formData.append("titularPoliza", titularPoliza);
    formData.append("telefono", telefono);
    formData.append("fechaSiniestro", fechaSiniestro);
    formData.append("marca", marca);
    formData.append("model", model);
    formData.append("anio", anio);
    formData.append("color", color);
    formData.append("conductor", conductor);
    formData.append("sinllamda", sinllamda);

    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/ValidarInformacion`, formData);
    return resp.data;
  },
  async ObtenerAgenteCalificado(vm, nrreporte, svindice) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/ObtenerAgenteCalificado`, formData);
    return resp.data;
  },
  async ActualizarCalificacionFinal(vm, nrreporte, svindice, reaid) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("reaid", reaid);
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());

    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/ActualizarCalificacionFinal`, formData);
    return resp.data;
  },

  async RestablecerCalificacion(vm, nrreporte, svindice, reaid) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("reaid", reaid);
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());

    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/RestablecerCalificacion`, formData);
    return resp.data;
  },
  async BuscarArchivoBucket(vm, nomArchivo, nrreporte, svindice, uslogin, fecha, anio, mes, dia) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("archivoBuscado", nomArchivo);
    formData.append("uslogin", uslogin);
    formData.append("fecha", fecha);
    formData.append("anio", anio);
    formData.append("mes", mes);
    formData.append("dia", dia);
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Archivos/BuscarArchivoBucket`, formData);
    return resp.data;
  },

  async guardarSeguimientoNPS(vm) {
    const formattedDate = new Date(vm.datosSeguimiento.fechaHora).toISOString();
    var formData = new FormData();
    formData.append("nrreporte", vm.datosSeguimiento.nrreporte);
    formData.append("svindice", vm.datosSeguimiento.svindice);
    formData.append("senpsfh", formattedDate);
    formData.append("senpsobsv", vm.datosSeguimiento.observaciones);
      formData.append("uslogin", MetodosGenerales.ObtenerUserName());
      formData.append("egid", vm.datosSeguimiento.egid);

    return axios
      .post(`${domain.domainNameForApi}Calidad/guardarSeguimientoNPS`, formData)
      .then((response) => response.data);
  },
  async ObtenerHistorialSegNPS(vm) {
    try {
      const formData = new FormData();
      formData.append("nrreporte", vm.Nrreporte);
        formData.append("svindice", vm.Svindice);
        formData.append("egid", vm.egid);

      return axios
        .post(
          `${domain.domainNameForApi}Calidad/ObtenerHistorialSegNPS`,
          formData
        )
        .then((response) => response.data);
    } catch (error) {
      console.error("Error obteniendo el historial:", error);
      throw error;
    }
  },
  async ObtenerUltimaLlamada(vm) {
    try {
      var formData = new FormData();
      formData.append("nrreporte", vm.Nrreporte);
      formData.append("svindice", vm.Svindice);
      formData.append("uslogin", MetodosGenerales.ObtenerUserName());

      return axios
        .post(
          `${domain.domainNameForApi}Calidad/ObtenerUltimaLlamada`,
          formData
        )
        .then((response) => response.data);
    } catch (error) {
      console.error("Error al obtener la ultima llamada:", error);
      throw error;
    }
  },

  obtenerFechaActual(vm) {
    var formData = new FormData();
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Calidad/ObtenerFechaActual`, formData)
      .then((response) => response.data);
  },
  async ObtenerMisPendientes(data) {
    data.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await axios.post(`${domain.domainNameForApi}Calidad/ObtenerMisPendientes`);
    return response.data;
  },
  async CambiarReporte(vm, nrreporte, svindice, uslogin, aleatorio, reporte) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    formData.append("usloginmodificacion", MetodosGenerales.ObtenerUserName());
    formData.append("uslogin", uslogin);
    formData.append("aleatorio", aleatorio);
    formData.append("reporte", reporte);

    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/CambiarReporte`, formData);
    return resp.data;
  },
  async ValidarReporte(vm, uslogin, reporte) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    formData.append("reporte", reporte);

    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/ValidarReporte`, formData);
    return resp.data[0];
  },
  async ObtenerEstadoProceso(vm, jobId) {
    var formData = new FormData();
    formData.append("jobId", jobId);
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/EstadodelProceso`, formData);
    return resp.data;
  },
  async ObtenerPreguntaRadio(vm, calificacion) {
    var formData = new FormData();
    formData.append("calificacion", calificacion);
    let resp = await vm.axios.post(`${vm.domain.domainNameForApi}Calidad/ObtenerPreguntaRadio`, formData);
    return resp.data;
  }
}
